import React, { useEffect, useState } from "react";
import { useParams } from 'react-router'
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";



export default function PaymentSuccess() {
    const params = useParams()
    const { login } = useSelector((item) => item.user);
    const [counter, setCounter] = useState(10);
    var { t } = useTranslation()




    useEffect(() => {
        document.title = t("difficulty_paying");
        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
        if (counter === 0) {
            window.location.href = '/'
        }
        if (login === false) {
            window.location.href = '/auth'
        }
    }, [counter]);

    function closeWindow() {
        if (typeof window !== 'undefined') {
            window.location.href = '/';
        }
    }



    return (
        <>
            <div className="flex flex-col items-center justify-center w-full h-screen">
                <div className="bg-red-500 bg-opacity-90 bg-transparent  rounded-lg shadow-lg p-5 w-[400px]">
                    <div className="flex flex-col items-center justify-center mt-6 space-y-7">
                        <p className="text-xl font-bold text-black">{t("payment_not_successful")}</p>
                        <p className="text-center text-black w-80">{t("make_the_operation")}</p>
                    </div>
                    <div className="flex justify-center w-full mt-20 ">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={0.7} stroke="currentColor" className="w-32 h-32 text-red-500 ">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                    <div className="flex flex-col items-center justify-center gap-2 mt-20 ">
                        <button type="button" onClick={() => closeWindow()} className="text-white  bg-neutral-800 bg-opacity-50 hover:bg-neutral-700  focus:outline-none  focus:ring-4  font-medium rounded-full text-sm px-5 py-2.5 text-center mr-2 mb-2 ">{t("return_the_page")}</button>
                        <p className="text-sm text-black " ><span>{counter}</span>{t("go_to_home_page")}</p>
                        <h4 className="text-xs text-black ">{t("product_id")} {params.id}</h4>
                    </div>
                </div>
            </div>



        </>
    )
}


